module.exports = __webpack_public_path__ + "static/media/moot5a.e2ba6d59.png";